import { mapErrorMessage } from '@/utils/helpers';
import { showToast } from '@/utils/toasts';

export function safeParseEmails(input: FormDataEntryValue | null): string[] {
  if (typeof input !== 'string') {
    throw new Error('Emails are missing');
  }
  try {
    return JSON.parse(input) as string[];
  } catch {
    throw new Error('Invalid email format');
  }
}

export function parseConstraints(
  currentInvitationsNum: string,
  currentUsersNum: string,
): {
  currentInvitationsNum: number;
  currentUsersNum: number;
} {
  const invitationsNum = parseInt(currentInvitationsNum, 10);
  const usersNum = parseInt(currentUsersNum, 10);

  if (Number.isNaN(invitationsNum) || Number.isNaN(usersNum)) {
    throw new Error('Provided constraints are not valid numbers');
  }

  return {
    currentInvitationsNum: invitationsNum,
    currentUsersNum: usersNum,
  };
}

export function handleInvitationError(error: unknown): {
  success: false;
  message: string;
} {
  const message = mapErrorMessage(error);

  showToast('Error!', message, 'error');
  console.error(error);

  return { success: false, message };
}
